<!--
 * @Description: 返回报名成功页
 * @Author: 山淑兰
 * @Date: 2019-12-16 10:41:17
 * @LastEditTime: 2020-07-15 16:22:01
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="backBtn">
    <div @click="back">返回</div>
  </div>
</template>
<script>
export default {
  name: 'backBtn',
  methods: {
    back() {
      if (this.$route.path == '/signup/modifyInfo') {
        delete this.$route.query.muid
      }
      this.$router.push({
        path: '/signup/signupinfo',
        query: this.$route.query,
      })
    },
  },
}
</script>
<style scoped lang="scss">
#backBtn {
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: #1989fa;
  text-align: center;
  font-size: 24px;
  color: #fff;
  border-radius: 40px;
}
</style>
